import * as api from "../api";
import {
  CREATECATEGORY,
  UPDATECATEGORY,
  DELETECATEGORY,
  FETCHCATEGORYS,
  FETCHCATEGORY,
} from "../constants/actionTypes";
import { message } from "antd";

export const createCategory =
  (FormData, history, setLoadingButton) => async (dispatch) => {
    try {
      const { data } = await api.createCategory(FormData);
      dispatch({ type: CREATECATEGORY, data });
      if (data) {
        setLoadingButton(false);
        history("/categories");
        message.success("Category added successfully");
      }
    } catch (error) {
      if (error) {
        setLoadingButton(false);
        console.log(error.response.data);
        message.error(error.response.data);
      }
    }
  };

export const getCategories = (storeId) => async (dispatch) => {
  try {
    const { data } = await api.getCategories(storeId);
    dispatch({ type: FETCHCATEGORYS, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const getCategory = (id) => async (dispatch) => {
  try {
    const { data } = await api.getCategory(id);
    dispatch({ type: FETCHCATEGORY, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const updateCategory =
  (id, formData, history, setLoadingButton) => async (dispatch) => {
    try {
      const { data } = await api.updateCategory(id, formData);
      dispatch({ type: UPDATECATEGORY, payload: data });
      if (data) {
        history("/categories");
        setLoadingButton(false);
      }
    } catch (error) {
      console.log(error);
      setLoadingButton(false);
    }
  };

export const deleteCategory = (id, history) => async (dispatch) => {
  try {
    const response = await api.deleteCategory(id);
    dispatch({ type: DELETECATEGORY, payload: id });
    if (response) {
      history("/categories");
      message.success("Catgory deleted successfully");
    }
  } catch (error) {
    console.log(error?.response?.data?.message);
    message.error(error?.response?.data?.message);
  }
};
